import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { SetupAwsPrivateLinkRequest } from '../models/SetupAwsPrivateLinkRequest';
import { SetupAwsPrivateLinkResponse } from '../models/SetupAwsPrivateLinkResponse';

/**
 * no description
 */
export class SetupAwsPrivateLinkApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Setup AWS PrivateLink for a resource
   * @param id ID of the inventory resource.
   * @param projectId The project ID.
   * @param setupAwsPrivateLinkRequest 
   */
  public async setupAwsPrivateLink(id: string, projectId: string, setupAwsPrivateLinkRequest: SetupAwsPrivateLinkRequest, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new RequiredError("SetupAwsPrivateLinkApi", "setupAwsPrivateLink", "id");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("SetupAwsPrivateLinkApi", "setupAwsPrivateLink", "projectId");
    }


    // verify required parameter 'setupAwsPrivateLinkRequest' is not null or undefined
    if (setupAwsPrivateLinkRequest === null || setupAwsPrivateLinkRequest === undefined) {
      throw new RequiredError("SetupAwsPrivateLinkApi", "setupAwsPrivateLink", "setupAwsPrivateLinkRequest");
    }


    // Path Params
    const localVarPath = '/projects/{projectId}/inventory/{id}/aws/private-link'
      .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.POST, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    // Body Params
    const contentType = "application/json"
    requestContext.setHeaderParam("Content-Type", contentType);
    const serializedBody = JSON.stringify(ObjectSerializer.serialize(setupAwsPrivateLinkRequest, "SetupAwsPrivateLinkRequest", ""));
    requestContext.setBody(serializedBody);

    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class SetupAwsPrivateLinkApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to setupAwsPrivateLink
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async setupAwsPrivateLinkWithHttpInfo(response: ResponseContext): Promise<HttpInfo<SetupAwsPrivateLinkResponse >> {
    if (isCodeInRange("202", response.httpStatusCode)) {
      const body: SetupAwsPrivateLinkResponse = ObjectSerializer.deserialize(
        await response.body.json(),
        "SetupAwsPrivateLinkResponse", ""
      ) as SetupAwsPrivateLinkResponse;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("400", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Invalid request body or parameters.", undefined, response.headers, response);
    }
    if (isCodeInRange("404", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Inventory item not found.", undefined, response.headers, response);
    }
    if (isCodeInRange("500", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Internal server error.", undefined, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: SetupAwsPrivateLinkResponse = await response.body.json() as SetupAwsPrivateLinkResponse;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
